


    (function ($) {

        $(window).load(function () {

            $('.animated_text').each(function(){
                var $this = $(this);
                let aboutElement =  $(this).find('p');


                $(this).children('p').each(function(){

                    let inner_elements = {}

                    $(this).children().each(function (){
                        inner_elements[$(this).text()] = $(this)
                    })


                    var aboutText = $(this).text();
                    let aboutSpans = '<span>' + aboutText.split("").join('</span><span>') + '</span>';

                    $.each( inner_elements, function( text, html ) {

                        let _spans = '<span>' + text.split("").join('</span><span>') + '</span>';
                        let _html = html.html(_spans)

                        _html = $("<dív></dív>").html(_html)

                        aboutSpans = aboutSpans.replace(_spans, _html.html())

                    });


                    $(this).text('');
                    $(this).append(aboutSpans);
                });

                var $startBG = 'rgb(192, 197, 206)';
                var $endBG = 'rgb(52, 61, 70)'
                if ($this.hasClass('color-white')){
                    $startBG = 'rgb(192, 197, 206)';
                    $endBG = 'rgb(255, 255, 255)';
                }


                var $start = 'top-=200px 70%';
                var $end = '95% 70%';
                if (aboutElement.hasClass('hp-about__text')){
                    $start = 'top 100%';
                    $end = 'bottom 100%';
                }

                gsap.fromTo(aboutElement.find('span, a'),
                    {
                        color: $startBG
                    },
                    {
                        color: $endBG,
                        duration: 0.1,
                        stagger: 0.2,
                        scrollTrigger: {
                            trigger: $this,
                            start: $start,
                            end: $end,
                            scrub: true,
                            toggleActions: 'play play reverse reverse'
                        }
                    })



            });


        })


    })(jQuery);


























